import React from 'react';
import './TermsAndConditionsModal.css';

function TermsAndConditionsModal({ isOpen, onClose, onAccept, disclaimerText }) {
  if (!isOpen) return null;

  const handleAccept = () => {
    if (onAccept) {
      onAccept();
    }
    onClose();
  };

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="terms-modal-header">
          <h2 className="terms-modal-title">Terms & Conditions</h2>
          <button
            className="terms-close-button"
            onClick={onClose}
            aria-label="Close terms"
          >
            ×
          </button>
        </div>

        {/* Terms Content */}
        <div className="terms-modal-body">
          {disclaimerText && (
            <div className="terms-section terms-section-disclaimer-api">
              <h3 className="terms-section-title">Medical Disclaimer</h3>
              <p className="terms-text terms-disclaimer-api-text">{disclaimerText}</p>
            </div>
          )}
          <div className="terms-section">
            <h3 className="terms-section-title">1. Acceptance of Terms</h3>
            <p className="terms-text">
              By accessing and using the Nyafaz AI Skin Analysis service ("the Service"), you hereby agree to be bound by these Terms and Conditions. Your use of the Service constitutes your legal acceptance of these terms. If you do not agree with any part of these terms, you must refrain from using the Service.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">2. Service Overview</h3>
            <p className="terms-text">
              Nyafaz provides advanced AI-driven dermatological assessments using proprietary facial scanning technology. The Service is designed to evaluate various skin health parameters and provide personalized insights.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">3. Professional Disclaimer</h3>
            <p className="terms-text">
              <strong>MEDICAL ADVICE DISCLAIMER:</strong> The Service is provided for informational and educational purposes only. It is NOT intended to be a substitute for professional medical advice, diagnosis, or treatment. Always consult with a qualified dermatologist or medical professional for any health-related concerns.
            </p>
            <ul className="terms-list">
              <li>Results do not constitute a clinical diagnosis.</li>
              <li>Nyafaz is not a medical device or a healthcare provider.</li>
              <li>Always prioritize the advice of your personal physician.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">4. Technology and Limitations</h3>
            <p className="terms-text">
              Our AI algorithms process facial characteristic data based on images provided by the user. Accuracy is subject to variables including image quality, lighting, and camera orientation. While we utilize state-of-the-art AI, results should be viewed as algorithmic assessments rather than absolute certainties.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">5. Data Privacy and Security</h3>
            <p className="terms-text">
              At Nyafaz, we prioritize the confidentiality of your personal information.
            </p>
            <ul className="terms-list">
              <li><strong>Secure Processing:</strong> All facial feature data is processed via encrypted cloud infrastructure.</li>
              <li><strong>Progress Tracking:</strong> Your analysis results are securely retained to enable progress monitoring and future skin health comparisons.</li>
              <li><strong>Confidentiality:</strong> We do not sell or share your personal data with third-party advertisers or unauthorized entities.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">6. User Commitments</h3>
            <p className="terms-text">
              Users agree to provide clear, unobstructed images and to follow all provided instructions for optimal analysis. You are responsible for ensuring your use of the Service complies with local regulations.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">7. Limitation of Liability</h3>
            <p className="terms-text">
              Nyafaz and its affiliates shall not be held liable for any decisions made or actions taken based on the Service's output. Users acknowledge the inherent technological limitations of AI assessments.
            </p>
          </div>

          <div className="terms-section">
            <h3 className="terms-section-title">8. Amendments</h3>
            <p className="terms-text">
              We reserve the right to update these Terms at any time. Continued use of the Service following such updates signifies your agreement to the revised terms.
            </p>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="terms-modal-footer">
          <button
            className="skin-action-button terms-understand-button"
            onClick={handleAccept}
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditionsModal;

